module.exports = __webpack_public_path__ + "img/bar-chart-grouped-light-01.54a4df1a.jpg";